import { postBiz, json, rows } from '../core/coreapi';
const SERVICE = 'biehistorical';


export const normalizeHistoricalImport = (r: any) => ({
  id: r.rid ?? r.recid ?? r.id,
  rid: r.rid ?? r.recid ?? null,
  rix: r.rix ?? r.recix ?? null,

  code: r.shc ?? r.shortcode ?? '',
  name: r.nam ?? r.recname ?? '',
  description: r.dsc ?? r.description ?? '',

  sourceid: r.soi ?? r.sourceid ?? null,
  sourcecode: r.soc ?? r.sourcecode ?? '',
  sourcename: r.son ?? r.sourcename ?? '',

  scenarioid: r.sci ?? r.scenarioid ?? null,
  scenariocode: r.scc ?? r.scenariocode ?? '',
  scenarioname: r.scn ?? r.scenarioname ?? '',

  trackid: r.tri ?? r.trackid ?? '',
  filename: r.fnm ?? r.filename ?? r.nam ?? '',
  importdate: r.dcd ?? r.importdate ?? r.created ?? null,

  recordcount: Number(r.trc ?? r.recordcount ?? 0),
  validcount: Number(r.vrc ?? r.validcount ?? 0),
  warningcount: Number(r.wrc ?? r.warningcount ?? 0),
  errorcount: Number(r.crc ?? r.errorcount ?? 0),
  failedcount: Number(r.frc ?? r.failedcount ?? 0),

  amount: Number(r.amt ?? r.amount ?? 0),
  validamount: Number(r.vam ?? r.validamount ?? 0),
  failedamount: Number(r.fam ?? r.failedamount ?? 0),

  percentage: Number(r.pct ?? r.percentage ?? 0),

  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',

  status: Number(r.ast ?? r.sts ?? r.status ?? 1),
  created: r.stp ?? r.created ?? null,
  extrainfo: r.exi ?? r.extrainfo ?? {},

  raw: r,
});                                            

export const normalizeHistoricalFact = (r: any) => ({
  id: r.rid ?? r.recid ?? r.id,
  rid: r.rid ?? r.recid ?? null,
  rix: r.rix ?? r.recix ?? null,

  code: r.shc ?? r.shortcode ?? '',
  name: r.nam ?? r.recname ?? '',
  description: r.dsc ?? r.description ?? '',

  sourceid: r.soi ?? r.sourceid ?? null,
  sourcecode: r.soc ?? r.sourcecode ?? '',
  sourcename: r.son ?? r.sourcename ?? '',

  scenarioid: r.sci ?? r.scenarioid ?? null,
  scenariocode: r.scc ?? r.scenariocode ?? '',
  scenarioname: r.scn ?? r.scenarioname ?? '',

  entityid: r.eni ?? r.entityid ?? null,
  entitycode: r.enc ?? r.entitycode ?? '',
  entityname: r.enn ?? r.entityname ?? '',

  locationid: r.lci ?? r.locationid ?? null,
  locationcode: r.lcc ?? r.locationcode ?? '',
  locationname: r.lcn ?? r.locationname ?? '',

  productid: r.pri ?? r.productid ?? null,
  productcode: r.prc ?? r.productcode ?? '',
  productname: r.prn ?? r.productname ?? '',

  periodid: r.pei ?? r.periodid ?? null,
  periodcode: r.pec ?? r.periodcode ?? '',
  periodname: r.pen ?? r.periodname ?? '',

  metricid: r.mti ?? r.metricid ?? null,
  metriccode: r.mtc ?? r.metriccode ?? '',
  metricname: r.mtn ?? r.metricname ?? '',

  quantity: Number(r.qty ?? r.quantity ?? 0),
  unitprice: Number(r.upr ?? r.unitprice ?? 0),
  amount: Number(r.amt ?? r.amount ?? 0),

  currencycode: r.ccy ?? r.currencycode ?? '',
  unitcode: r.unt ?? r.unitcode ?? '',

  valueorigin: r.voc ?? r.valueorigin ?? '',
  valueorigindesc: r.von ?? r.valueorigindesc ?? '',

  approved: Boolean(r.apr ?? false),

  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',

  status: Number(r.ast ?? r.sts ?? r.status ?? 1),

  created: r.dcd ?? r.created ?? null,
  modified: r.stp ?? r.stamp ?? null,

  extrainfo: r.exi ?? {},
  raw: r,
});

export const fetchHistoricalCards = async () =>
  json(await postBiz({ s: 'biehistorical', a: 'cards' }));

export const fetchHistoricalImports = async (f: any) =>
  rows(
    await postBiz({
      s: 'biehistorical',
      a: 'imports',
      soc: f.sourcecode || null,
      sts: f.status ?? null,
      pos: f.page || 0,
      plm: f.pagesize || 50,
    })
  ).map(normalizeHistoricalImport);

export const fetchHistoricalFacts = async (f: any) =>
  rows(
    await postBiz({
      s: 'biehistorical',
      a: 'facts',
      scc: f.scenariocode || null,
      dsc: f.datasetcode || null,
      pdc: f.periodcode || null,
      pos: f.page || 0,
      plm: f.pagesize || 100,
    })
  ).map(normalizeHistoricalFact);

export const uploadHistoricalData = async (payload: any) =>
  json(await postBiz({ s: 'biehistorical', a: 'upload', ...payload }));

export const validateHistoricalImport = async (importid: number) =>
  json(await postBiz({ s: 'biehistorical', a: 'validate', rid: importid }));

export const publishHistoricalImport = async (importid: number) =>
  json(await postBiz({ s: 'biehistorical', a: 'publish', rid: importid }));
